$(function() {
    
    if ($('body').hasClass('template-index')) {
        $('.mainvisual_slider').slick({
            dots: true,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear'
        });

        $(window).on('load', function() {
            $('#shopify-section-16048922206f41b10b').appendTo('.top-content');
            $('#shopify-section-16048922206f41b10b').prepend('<h2>INSTAGRAM</h2>');
        });
    }

    $('#menuButton').on('click', function() {
        if ($(this).hasClass('is-active')) {
            $(this).removeClass('is-active');
            $('.sitemap').removeClass('is-active');
        } else {
            $(this).addClass('is-active');
            $('.sitemap').addClass('is-active');
        }
    });

    $('.header_wrap_icn .r-iconList .search').on('click', function() {
        $('.searchMdl').addClass('is-active');
    });

    $('.searchMdl_inner_box .searchClose').on('click', function() {
        $('.searchMdl').removeClass('is-active');
    });

    var replaceWidth = 768;
    (function() {
        var $setElem = $('.switch'),
            pcName = '_pc',
            spName = '_sp';

        $setElem.each(function() {
            var $this = $(this);

            function imgSize() {
                var winWidth = window.innerWidth;
                if (winWidth != 'undefind') {
                    if (winWidth <= replaceWidth) {
                        $this.attr('src', $this.attr('src').replace(pcName, spName));
                    } else {
                        $this.attr('src', $this.attr('src').replace(spName, pcName));
                    }
                }
            }

            $(window).on('resize', function() {
                imgSize();
            });

            imgSize();
        });
    })();

    if ($('body').hasClass('template-product')) {
        $('.infobox .ttl').on('click', function() {
            if ($(this).hasClass('is-active')) {
                $(this).removeClass('is-active');
                $(this).next().slideUp();
            } else {
                $(this).addClass('is-active');
                $(this).next().slideDown();
            }
        });

        $('.product-contact').on('click', function() {
            $('.single-form').removeClass('hide');
        });

        $('.single-form-modal .closeBtn').on('click', function() {
            $('.single-form').addClass('hide');
        });

        $('#ContactFormUrl').val(location.href);

        if ($('.form-success').length) {
            $('.note.form-success').prependTo('.product-single');
        }

        if (
            typeof $.fn.slick !== 'undefined' &&
            $('.js-product-main-slider').length &&
            $('#ProductSection').length
        ) {
            var $section = $('#ProductSection');
            var sectionId = $section.data('section-id');
            var $mainSlider = $section.find('.js-product-main-slider');
            var $thumbs = $section.find('#ProductThumbs .product-single__thumbnail');
            var $variantSelect = $('#ProductSelect-' + sectionId);
            var productJsonEl = document.getElementById('ProductJson-' + sectionId);
            var productData = null;

            if (!productJsonEl) return;

            try {
                productData = JSON.parse(productJsonEl.textContent);
            } catch (e) {
                console.error('Product JSON の解析に失敗しました', e);
                return;
            }

            function getUrlVariantId() {
                var params = new URLSearchParams(window.location.search);
                return params.get('variant');
            }

            function isValidVariantId(val) {
                return !!val && /^\d+$/.test(String(val));
            }

            function getVariantIdFromSelect() {
                if (!$variantSelect.length) return null;
                var val = $variantSelect.val();
                return isValidVariantId(val) ? String(val) : null;
            }

            function getVariantIdFromCheckedInputs() {
                var $checked = $section.find(
                    'input[name="id"]:checked, input[name="id"][type="radio"]:checked, .variant-input:checked, .variant-input-wrap input:checked'
                ).first();

                if ($checked.length) {
                    var val = $checked.val();
                    if (isValidVariantId(val)) return String(val);
                }

                return null;
            }

            function getVariantIdFromHiddenIdInput() {
                var $input = $section.find('form[action*="/cart/add"] input[name="id"][type="hidden"]').first();
                if ($input.length) {
                    var val = $input.val();
                    if (isValidVariantId(val)) return String(val);
                }
                return null;
            }

            function getCurrentVariantId() {
                return (
                    getVariantIdFromSelect() ||
                    getVariantIdFromCheckedInputs() ||
                    getVariantIdFromHiddenIdInput() ||
                    getUrlVariantId()
                );
            }

            function scrollToMainImage() {
                if (!$mainSlider.length) return;

                $('html, body').stop().animate({
                    scrollTop: $mainSlider.offset().top - 110
                }, {
                    queue: false,
                    duration: 400
                });
            }

            function setActiveThumbByIndex(index) {
                $thumbs.removeClass('is-active');
                $thumbs.filter('[data-slide-index="' + index + '"]').addClass('is-active');
            }

            function getSlideIndexByImageId(imageId) {
                var $target = $mainSlider.find('.product-single__image-slide[data-image-id="' + imageId + '"]');
                if (!$target.length) return 0;

                var rawIndex = parseInt($target.attr('data-slide-index'), 10);
                return isNaN(rawIndex) ? 0 : rawIndex;
            }

            function getVariantById(variantId) {
                if (!productData || !productData.variants || !variantId) return null;

                variantId = String(variantId);

                for (var i = 0; i < productData.variants.length; i++) {
                    if (String(productData.variants[i].id) === variantId) {
                        return productData.variants[i];
                    }
                }
                return null;
            }

            function getInitialSlideIndex() {
                var variant = getVariantById(getCurrentVariantId());

                if (variant && variant.featured_image && variant.featured_image.id) {
                    return getSlideIndexByImageId(variant.featured_image.id);
                }

                var featuredImageId = $mainSlider.attr('data-featured-image-id');
                if (featuredImageId) {
                    return getSlideIndexByImageId(featuredImageId);
                }

                return 0;
            }

            function goToSlideByIndex(index, withScroll, dontAnimate) {
                if (!$mainSlider.hasClass('slick-initialized')) return;

                if (typeof index !== 'number' || isNaN(index)) {
                    index = 0;
                }

                $mainSlider.slick('slickGoTo', index, !!dontAnimate);
                setActiveThumbByIndex(index);

                if (withScroll) {
                    scrollToMainImage();
                }
            }

            function goToSlideByImageId(imageId, withScroll, dontAnimate) {
                if (!imageId) return;
                goToSlideByIndex(getSlideIndexByImageId(imageId), withScroll, dontAnimate);
            }

            function syncToVariantId(variantId, withScroll, dontAnimate) {
                var variant = getVariantById(variantId);
                if (!variant) return;

                if (variant.featured_image && variant.featured_image.id) {
                    goToSlideByImageId(variant.featured_image.id, withScroll, dontAnimate);
                }
            }

            function syncToSelectedVariant(withScroll, dontAnimate) {
                var currentVariantId = getCurrentVariantId();
                if (!currentVariantId) return;
                syncToVariantId(currentVariantId, withScroll, dontAnimate);
            }

            function disableLightboxTemporarily() {
                $mainSlider.find('.zoom-lightbox').addClass('js-lightbox-disabled').removeClass('zoom-lightbox');
            }

            function restoreLightbox() {
                $mainSlider.find('.js-lightbox-disabled').addClass('zoom-lightbox').removeClass('js-lightbox-disabled');
            }

            function syncVariantMultipleTimes(variantId) {
                if (!variantId) return;

                setTimeout(function() {
                    syncToVariantId(variantId, false, true);
                }, 10);

                setTimeout(function() {
                    syncToVariantId(variantId, false, true);
                }, 80);

                setTimeout(function() {
                    syncToVariantId(variantId, false, true);
                }, 250);

                setTimeout(function() {
                    syncToVariantId(variantId, false, true);
                }, 500);
            }

            function watchUrlVariantChange() {
                var lastVariantId = getUrlVariantId();
                var lastHref = location.href;

                setInterval(function() {
                    var currentHref = location.href;
                    var currentVariantId = getUrlVariantId();

                    if (currentHref !== lastHref) {
                        lastHref = currentHref;

                        if (currentVariantId && currentVariantId !== lastVariantId) {
                            lastVariantId = currentVariantId;
                            syncVariantMultipleTimes(currentVariantId);
                        }
                    }
                }, 300);
            }

            function watchVariantUiInteractions() {
                $(document).on(
                    'click.productSlider change.productSlider',
                    '.single-option-selector, .swatch input, .swatch label, .variant-input, .variant-input-wrap input, .variant-input-wrap label, [name="id"]',
                    function() {
                        setTimeout(function() {
                            syncToSelectedVariant(false, true);
                        }, 50);

                        setTimeout(function() {
                            syncToSelectedVariant(false, true);
                        }, 200);

                        setTimeout(function() {
                            syncToSelectedVariant(false, true);
                        }, 500);
                    }
                );
            }

            function hookSelectCallback() {
                if (typeof window.selectCallback !== 'function') return;
                if (window.__productSliderSelectCallbackHooked) return;

                var originalSelectCallback = window.selectCallback;

                window.selectCallback = function(variant, selector) {
                    originalSelectCallback.apply(this, arguments);

                    if (variant && variant.featured_image && variant.featured_image.id) {
                        syncVariantMultipleTimes(String(variant.id));
                    }
                };

                window.__productSliderSelectCallbackHooked = true;
            }

            if ($mainSlider.hasClass('slick-initialized')) {
                $mainSlider.slick('unslick');
            }

            $mainSlider.off('.productSlider');
            $thumbs.off('.productSlider');
            $variantSelect.off('.productSlider');
            $(document).off('.productSlider');
            $(window).off('.productSlider');

            // ★ 修正：Slick初期化前に画像のない空スライドを削除
            $mainSlider.children().each(function() {
                if ($(this).find('img').length === 0) {
                    $(this).remove();
                }
            });

            $mainSlider.on('init.productSlider', function(event, slick) {
                setActiveThumbByIndex(slick.currentSlide || 0);
            });

            $mainSlider.on('afterChange.productSlider', function(event, slick, currentSlide) {
                setActiveThumbByIndex(currentSlide);
            });

            $mainSlider.on('beforeChange.productSlider', function(event, slick, currentSlide, nextSlide) {
                var last = slick.slideCount - 1;
                if (nextSlide < 0 || nextSlide > last) {
                    setTimeout(function() {
                        $mainSlider.slick('slickGoTo', currentSlide, true);
                    }, 0);
                }
            });

            $mainSlider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: false,
                speed: 450,
                cssEase: 'ease',
                adaptiveHeight: true,
                swipe: true,
                draggable: true,
                touchThreshold: 10,
                edgeFriction: 0.35,
                initialSlide: getInitialSlideIndex()
            });

            (function() {
                var $track = $mainSlider.find('.slick-track');
                var slideW = $mainSlider.width();
                var slideCount = $mainSlider.slick('getSlick').slideCount;
                var maxTranslate = -(slideCount - 1) * slideW;

                var observer = new MutationObserver(function() {
                    var style = $track[0].style.transform;

                    var m3d = style.match(/^translate3d\(([-\d.]+)px,/);
                    if (m3d) {
                        var x = parseFloat(m3d[1]);
                        if (x > 0) {
                            $track[0].style.transform = 'translate3d(0px, 0px, 0px)';
                        } else if (x < maxTranslate) {
                            $track[0].style.transform = 'translate3d(' + maxTranslate + 'px, 0px, 0px)';
                        }
                        return;
                    }

                    var mm = style.match(/^(matrix\(\s*[\d.]+,\s*[\d.]+,\s*[\d.]+,\s*[\d.]+,\s*)([-\d.]+)(,.*)$/);
                    if (mm) {
                        var x2 = parseFloat(mm[2]);
                        if (x2 > 0) {
                            $track[0].style.transform = mm[1] + '0' + mm[3];
                        } else if (x2 < maxTranslate) {
                            $track[0].style.transform = mm[1] + maxTranslate + mm[3];
                        }
                    }
                });

                observer.observe($track[0], { attributes: true, attributeFilter: ['style'] });

                $(window).on('resize.productSlider', function() {
                    slideW = $mainSlider.width();
                    maxTranslate = -(slideCount - 1) * slideW;
                });
            })();

            $thumbs.on('click.productSlider', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var index = parseInt($(this).attr('data-slide-index'), 10);
                if (isNaN(index)) return;

                goToSlideByIndex(index, true, false);
            });

            if ($variantSelect.length) {
                $variantSelect.on('change.productSlider', function() {
                    setTimeout(function() {
                        syncToSelectedVariant(false, true);
                    }, 50);

                    setTimeout(function() {
                        syncToSelectedVariant(false, true);
                    }, 200);

                    setTimeout(function() {
                        syncToSelectedVariant(false, true);
                    }, 500);
                });
            }

            $(document).on('variantImageChange.productSlider', function(event, data) {
                if (data && data.imageId) {
                    goToSlideByImageId(data.imageId, false, true);
                }
            });

            watchUrlVariantChange();
            watchVariantUiInteractions();
            hookSelectCallback();

            syncToSelectedVariant(false, true);
            setTimeout(function() {
                syncToSelectedVariant(false, true);
            }, 150);
            setTimeout(function() {
                syncToSelectedVariant(false, true);
            }, 400);
            setTimeout(function() {
                syncToSelectedVariant(false, true);
            }, 800);

            var isPointerDown = false;
            var isDragging = false;
            var startX = 0;
            var startY = 0;
            var suppressClick = false;
            var blockEdgeSwipe = false;

            function getSlickState() {
                if (!$mainSlider.hasClass('slick-initialized')) return null;
                return $mainSlider.slick('getSlick');
            }

            function getPoint(e) {
                var oe = e.originalEvent || e;
                if (oe.touches && oe.touches.length) return oe.touches[0];
                if (oe.changedTouches && oe.changedTouches.length) return oe.changedTouches[0];
                return oe;
            }

            $mainSlider.on('mousedown.productSlider touchstart.productSlider pointerdown.productSlider', function(e) {
                var point = getPoint(e);
                isPointerDown = true;
                isDragging = false;
                blockEdgeSwipe = false;
                startX = point.clientX;
                startY = point.clientY;
            });

            $mainSlider.on('mousemove.productSlider touchmove.productSlider pointermove.productSlider', function(e) {
                if (!isPointerDown) return;

                var point = getPoint(e);
                var diffX = point.clientX - startX;
                var diffY = point.clientY - startY;
                var slickObj = getSlickState();

                if (Math.abs(diffX) > 8 || Math.abs(diffY) > 8) {
                    if (!isDragging) {
                        disableLightboxTemporarily();
                    }
                    isDragging = true;
                }

                if (!slickObj) return;

                var currentIndex = slickObj.currentSlide;
                var lastIndex = slickObj.slideCount - 1;
                var horizontalMove = Math.abs(diffX) > Math.abs(diffY);

                if (!horizontalMove) return;

                if (currentIndex === 0 && diffX > 12) {
                    blockEdgeSwipe = true;
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }

                if (currentIndex === lastIndex && diffX < -12) {
                    blockEdgeSwipe = true;
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                }
            });

            $mainSlider.on('mouseup.productSlider touchend.productSlider touchcancel.productSlider pointerup.productSlider pointercancel.productSlider mouseleave.productSlider', function() {
                if (isDragging || blockEdgeSwipe) {
                    suppressClick = true;
                    setTimeout(function() {
                        suppressClick = false;
                        restoreLightbox();
                    }, 250);
                } else {
                    restoreLightbox();
                }

                isPointerDown = false;
                isDragging = false;
                blockEdgeSwipe = false;
            });

            var sliderEl = $mainSlider.get(0);
            if (sliderEl && !sliderEl.__productSliderClickGuardAttached) {
                sliderEl.addEventListener('click', function(e) {
                    if (isDragging || suppressClick || blockEdgeSwipe || $mainSlider.hasClass('slick-dragging')) {
                        e.preventDefault();
                        e.stopPropagation();
                        e.stopImmediatePropagation();
                    }
                }, true);
                sliderEl.__productSliderClickGuardAttached = true;
            }

            $mainSlider.on('click.productSlider', '.product-single__image, .product-single__image-wrapper', function(e) {
                if (isDragging || suppressClick || blockEdgeSwipe || $mainSlider.hasClass('slick-dragging')) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                }
            });

            $mainSlider.on('swipe.productSlider', function(event, slick, direction) {
                var current = slick.currentSlide;
                var last = slick.slideCount - 1;
                if ((current === 0 && direction === 'right') || (current === last && direction === 'left')) {
                    goToSlideByIndex(current, false, false);
                }
            });

            var sliderDomEl = $mainSlider.get(0);
            if (sliderDomEl) {
                sliderDomEl.addEventListener('touchmove', function(e) {
                    if (!isPointerDown) return;
                    var touch = e.touches[0];
                    if (!touch) return;
                    var diffX = touch.clientX - startX;
                    var diffY = touch.clientY - startY;
                    if (Math.abs(diffX) <= Math.abs(diffY)) return;
                    var slickObj = getSlickState();
                    if (!slickObj) return;
                    var currentIndex = slickObj.currentSlide;
                    var lastIndex = slickObj.slideCount - 1;
                    if ((currentIndex === 0 && diffX > 12) || (currentIndex === lastIndex && diffX < -12)) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }, { passive: false });
            }

        } else {
            var position = $(".product-single__image-wrapper").offset() ? $(".product-single__image-wrapper").offset().top : 0;
            $('.thumbnails').on('click', function() {
                $("html,body").animate({
                    scrollTop: position - 110
                }, {
                    queue: false
                });
            });
        }
    }

    $('input[type="number"]').focusout(function() {
        if (typeof $(this).attr('min') !== "undefined" && parseInt($(this).val()) < parseInt($(this).attr('min')))
            $(this).val($(this).attr('min'));
        else if (typeof $(this).attr('max') !== "undefined" && parseInt($(this).val()) > parseInt($(this).attr('max')))
            $(this).val($(this).attr('max'));
        else if (typeof $(this).attr('min') !== "undefined" && $(this).val() === '')
            $(this).val($(this).attr('min'));
    });

    setTimeout(function() {
        if ($('.template-product').length && $('button:contains("Coming Soon..")').length) {
            $('#AddToCart').css('display', 'none');
        }
    }, 500);

    setTimeout(function() {
        if ($('.template-product').length && $('button:contains("Coming Soon..")').length) {
            $('#AddToCart').css('display', 'none');
        }
    }, 1000);

    setTimeout(function() {
        if ($('.template-product').length && $('button:contains("Coming Soon..")').length) {
            $('#AddToCart').remove();
        }
    }, 1500);
});